import { render, staticRenderFns } from "./ProcessReport.vue?vue&type=template&id=b342e45a&scoped=true&"
import script from "./ProcessReport.vue?vue&type=script&lang=js&"
export * from "./ProcessReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b342e45a",
  null
  
)

export default component.exports